import Marquee from "react-fast-marquee";

const DEFAULT_ITEMS = [
  "Dental Labs",
  "Digital Studio",
  "Implant Centers",
  "CAD/CAM Workflows",
  "Multi location accounts",
  "Dental Offices",
  "Digital Dentistry",
];

export default function MarqueeStrip({ items = DEFAULT_ITEMS, speed = 22 }) {
  return (
    <section
      data-testid="marquee-strip"
      className="relative border-y hairline py-5 overflow-hidden mask-fade-x bg-background"
    >
      <Marquee gradient={false} speed={speed} pauseOnHover={false}>
        {items.concat(items).map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-5 px-5 lg:px-6 whitespace-nowrap"
          >
            <span className="font-heading text-lg sm:text-xl lg:text-2xl tracking-tight text-foreground/75">
              {item}
            </span>
            <span
              aria-hidden
              className="inline-block h-1.5 w-1.5 rounded-full bg-brand-gradient"
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
